/** Browser-only demo policy. No production security or IP tracking. */
import type { LoginPolicyValues } from '@/services/business/security/types';
import { defaultLoginCaptchaConfig } from '../business/security-seed';

export type LoginCaptchaConfig = Omit<LoginPolicyValues, 'security'>;
export const loginCaptchaConfig: LoginCaptchaConfig = structuredClone(
  defaultLoginCaptchaConfig,
);
